import { render, staticRenderFns } from "./tencent-viewer.vue?vue&type=template&id=320e6af4"
import script from "./tencent-viewer.vue?vue&type=script&lang=js"
export * from "./tencent-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports